/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_Cat_RequiredInputs */

const tr_cerez_cat_required = /** @type {(inputs: Cerez_Cat_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zorunlu`)
};

const en_cerez_cat_required = /** @type {(inputs: Cerez_Cat_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessary`)
};

const de_cerez_cat_required = /** @type {(inputs: Cerez_Cat_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

const ru_cerez_cat_required = /** @type {(inputs: Cerez_Cat_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обязательный`)
};

/**
* | output |
* | --- |
* | "Necessary" |
*
* @param {Cerez_Cat_RequiredInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_cat_required = /** @type {((inputs?: Cerez_Cat_RequiredInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_Cat_RequiredInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_cat_required(inputs)
	if (locale === "de") return de_cerez_cat_required(inputs)
	if (locale === "ru") return ru_cerez_cat_required(inputs)
	return tr_cerez_cat_required(inputs)
});